import { Routes } from '../types/constants';
import { Video, VideoCornerColor } from '../types/video.types';
import { VideoCardData, VideoCardParticipant } from '../types/video-card.types';

const cornerRank = (cornerColor?: VideoCornerColor | null) => {
    if (cornerColor === 'blue') return 0;
    if (cornerColor === 'red') return 2;
    return 1;
};

export const orderVideoCardParticipants = (participants: VideoCardParticipant[]) => (
    [...participants].sort((left, right) => cornerRank(left.cornerColor) - cornerRank(right.cornerColor))
);

export const formatVideoCardParticipantName = (name?: string | null) => {
    const trimmed = name?.trim();
    return trimmed && trimmed.length > 0 ? trimmed : 'TBD';
};

export const formatVideoCardDate = (value?: string | null) => {
    if (!value) return null;
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
        return null;
    }
    return new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric', year: 'numeric' }).format(parsed);
};

export const formatVideoCardFightNumber = (value?: number | null) => {
    if (!value || value < 1) return null;
    return `Fight ${value}`;
};

const mapParticipant = (participant: Video['Participants'][number]): VideoCardParticipant => ({
    name: participant.ParticipantName,
    cornerColor: participant.CornerColor ?? null
});

/**
 * Build a UI-friendly video card model from API video data.
 */
export const buildVideoCardData = (video: Video): VideoCardData => ({
    id: video.Id || video.Url,
    watchUrl: `${Routes.WATCH}?v=${video.Url}`,
    title: video.Title,
    thumbnailUrl: video.ThumbnailBase64 ?? null,
    participants: (video.Participants ?? []).map(mapParticipant),
    eventDate: video.EventDate ?? null,
    fightNumber: video.FightNumber ?? null,
    eventName: video.EventName ?? null,
    venueName: video.LocationName ?? null,
    purchaseEnabled: video.PurchaseEnabled ?? null,
    purchasePrice: video.PurchasePrice ?? null,
    purchaseAccessUntil: video.PurchaseAccessUntil ?? null
});
